// Components
import InformationItem from './sub-components/InformationItem';

// Node Modules
import { nanoid } from 'nanoid';

// Themes
import theme from '@/themes/index';

const InstitutionInformation = ({
  content: {
    additionalItems, 
  }, 
}) => {
  return (
    <>
      <div className='items-container'>
        {additionalItems.map(item => (
          <InformationItem key={nanoid()} content={item}></InformationItem>
        ))}
      </div>
      <div className='dele-description'>
        <p><span className='dele-description-title'>Diplomas de Español DELE:</span> They are issued by the Instituto Cervantes, and they are official qualifications accrediting levels of competence and command of the Spanish language.</p>
      </div>
      <style jsx>{`
        div.items-container {
          display: flex;
          flex-direction: column;
          gap: 4rem;
        }

        .dele-description-title {
          font-family: ${theme.fontFamilies.montserratBold};
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.items-container {
            display: flex;
            flex-direction: row;
            column-count: 2;
            column-gap: 9.0625rem;
            gap: 2rem;
          }
        }
      `}</style>
    </>
  );
};

export default InstitutionInformation;
